/**
 * TASK-975 — roster rows for All Mechanics at This Shop.
 */
import { formatUsPhoneDisplay } from "./shopPublicPhone";

export function rosterRoleLabel(role) {
  if (role === "Owner") return "Owner";
  if (role === "Sales") return "Sales";
  return "Mechanic";
}

export function rosterContactLine(email, phone) {
  const mail = email ? `Email: ${email}` : "Email: —";
  const formatted = phone ? formatUsPhoneDisplay(phone) : "";
  return `${mail} | Phone: ${formatted || "—"}`;
}
